import CentroCusto from '../../spa/centro-custo/CentroCusto';

export default {
  path: 'centro-custo',
  name: 'centro-custo',
  component: CentroCusto,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/centro-custo.js